import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import api from "@/lib/api";

const Testimonials = () => {
    const [items, setItems] = useState([]);

    useEffect(() => {
        api.get("/testimonials").then((r) => setItems(r.data)).catch(() => {});
    }, []);

    if (!items.length) return null;

    return (
        <section
            data-testid="testimonials-section"
            className="bg-[var(--st-cream-soft)] relative z-10 py-24 lg:py-32"
        >
            <div className="st-container">
                <p className="eyebrow text-[var(--st-gold-deep)] mb-12">04 — Kind words, real names</p>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-10 lg:gap-16">
                    {items.map((t, i) => (
                        <motion.figure
                            key={t.id}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ duration: 0.8, delay: i * 0.15 }}
                            className="relative"
                            data-testid={`testimonial-${i}`}
                        >
                            <span className="font-serif text-9xl text-[var(--st-gold)] leading-none absolute -top-6 -left-2 opacity-50 select-none">"</span>
                            <blockquote className="font-serif text-2xl md:text-3xl leading-snug text-[var(--st-ink)] relative pl-8">
                                {t.quote}
                            </blockquote>
                            <figcaption className="mt-8 flex items-center gap-4 pl-8">
                                {t.avatar && (
                                    <img
                                        src={t.avatar}
                                        alt={t.author}
                                        className="w-14 h-14 rounded-full object-cover grayscale"
                                    />
                                )}
                                <div>
                                    <p className="font-medium text-[var(--st-ink)]">{t.author}</p>
                                    <p className="text-sm text-[var(--st-ink-soft)]">{t.role}, {t.company}</p>
                                </div>
                            </figcaption>
                        </motion.figure>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Testimonials;
